import React from "react";
import { useTranslation } from "react-i18next";
import MainHeader from "../../components/common/MainHeader";
import { URL_INTERFACE_AX } from "../../constance/urls";
import { POST } from "../../utils/HttpClient";
import { Toast } from "../../utils/Toast";
import * as _ from "lodash";
import { FileTextFilled } from "@ant-design/icons";
import {
  Alert,
  Typography,
  Form,
  Col,
  Space,
  DatePicker,
  Input,
  Row,
} from "antd";
import TSTable from "../../components/common/TSTable.js";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import InterfaceAXTransactionModal from "../../components/interface-ax/InterfaceAXTransactionModal";
import dayjs from "dayjs";
import { useDebounce } from "use-debounce";
import { BLUE_COLOR } from "../../constance/color";
import ColorButton from "../../components/common/ColorButton.js";

export default function InterfaceAXMovementIssueView() {
  const [form] = Form.useForm();
  const { Title } = Typography;
  const { t } = useTranslation();
  const [target, setTarget] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMsg, setErrMsg] = React.useState(null);
  const searchText = Form.useWatch("search", form);
  const [debouncedText] = useDebounce(searchText, 500);
  const date = Form.useWatch("created", form);
  const tableRef = React.createRef();
  const [hasSearched, setHasSearched] = React.useState(false);

  const columns = React.useMemo(
    () => [
      {
        title: t("date"),
        dataIndex: "created",
        render: (__, original) =>
          new Date(original.created).toLocaleString("en-GB"),
      },
      {
        title: t("factory_wood_exports.order_no"),
        dataIndex: "order_no",
      },
      {
        title: t("factory_wood_exports.destination_factory"),
        dataIndex: "destination_factory",
      },
      {
        title: t("trucks.license_plate"),
        dataIndex: "license_plate",
        render: (__, original) => (
          <div>
            {original.license_plate ? `${original.license_plate}` : "-"}
          </div>
        ),
      },
      {
        title: () => null,
        dataIndex: "id",
        render: (__, original) => {
          const target = _.get(original, "id", null);
          const progressing = _.get(original, "interface_progressing", false);
          return (
            <Space>
              <ColorButton
                variant="outlined"
                color="primary"
                override={BLUE_COLOR}
                disabled={progressing}
                onClick={() => !progressing && handleDoInterfaceAX(target)}
              >
                {progressing ? t("progressing") : t("do_interface_ax")}
              </ColorButton>
              <ColorButton
                variant="outlined"
                color="primary"
                override={BLUE_COLOR}
                icon={<FileTextFilled />}
                onClick={() => setTarget(target)}
              />
            </Space>
          );
        },
      },
    ],
    [date]
  );

  const handleDoInterfaceAX = async (id) => {
    setIsLoading(true);
    setErrMsg(null);
    try {
      const response = await POST(
        `${URL_INTERFACE_AX.MOVEMENT_ISSUE}${id}/do_interface/`
      );
      Toast.success(t("success"));
      if (tableRef.current) {
        tableRef.current.fetch();
      }
    } catch (error) {
      setErrMsg(error.errorMessages);
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    if (!hasSearched) {
      setHasSearched(true);
      return;
    } else {
      const params = {
        date: date ? dayjs(date).format(DATE_FORMAT) : null,
        search: debouncedText,
      };
      tableRef.current.fetch(params);
    }
  }, [date, debouncedText]);

  return (
    <div style={{ margin: "24px", marginTop: "7em" }}>
      <MainHeader />
      <Title level={2}>
        {t("menus.interface_ax")}:{" "}
        {t("menus.interface_ax_menus.movement_issue")}
      </Title>
      <Form form={form}>
        <Row>
          <Space>
            <Col>
              <Form.Item label={t("searchs.fields.date")} name={"created"}>
                <DatePicker
                  format={HUMAN_DATE_FORMAT}
                  placeholder={t("searchs.placeholders.date")}
                  style={{ width: 200 }}
                />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label={t("search")} name={"search"}>
                <Input placeholder={t("search")} allowClear />
              </Form.Item>
            </Col>
          </Space>
        </Row>
      </Form>

      {errorMsg && (
        <Alert
          message={
            <span style={{ color: "red" }}>
              <strong>{t("error")}</strong>
            </span>
          }
          description={<div style={{ color: "red" }}>{errorMsg}</div>}
          type="error"
        />
      )}
      <br />

      <TSTable
        scroll={{ x: 1000 }}
        ref={tableRef}
        url={URL_INTERFACE_AX.MOVEMENT_ISSUE}
        columns={columns}
        showSearch
        showSize
        showPagination
        params={{
          date_before: date ? dayjs(date).format(DATE_FORMAT) : null,
          date_after: date ? dayjs(date).format(DATE_FORMAT) : null,
          search: debouncedText,
        }}
        isLoading={isLoading}
      />
      <InterfaceAXTransactionModal
        open={target != null}
        onClose={() => setTarget(null)}
        onInterfaceAX={handleDoInterfaceAX}
        url={URL_INTERFACE_AX.MOVEMENT_ISSUE}
        target={target}
      />
    </div>
  );
}
